<template>
  <div>
    <b-card>
      <!-- loading -->
      <div v-if="this.loadpage == true" class="text-center">
        <b-spinner
          style="width: 5rem; height: 5rem;"
          variant="primary"
          label="Large Spinner"
        />
      </div>
      <b-form v-if="this.loadpage == false">
        <b-row>
          <b-col>
            <h4>ฟอร์มชำระเงิน</h4>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <!-- payment by -->
          <b-col cols="12">
            <b-form-group
              class="font-weight-bolder"
              label="ชำระโดย :"
              label-cols-md="3"
            >
              <b-form-radio
                v-model="choosePayment"
                plain
                name="payment"
                value="A"
              >
                <h6 class="font-weight-normal">โอนเงินผ่านธนาคาร</h6>
              </b-form-radio>
              <b-form-radio
                v-model="choosePayment"
                plain
                name="payment"
                value="B"
              >
                <h6 class="font-weight-normal">หักยอดเงินบาทจาก Balance</h6>
              </b-form-radio>
              <!-- <b-form-radio
                v-model="choosePayment"
                plain
                name="payment"
                value="C"
              >
                <h6 class="font-weight-normal">หักยอดเงินหยวนจาก Balance</h6>
              </b-form-radio> -->
            </b-form-group>
          </b-col>
          <!-- bank -->
          <b-col cols="12" v-if="choosePayment == 'A'">
            <h6 v-if="this.valBank == false" class="text-danger d-block d-sm-none">กรุณาระบุ</h6>
            <b-form-group
              class="font-weight-bolder mt-n1 pt-md-1"
              label="ธนาคาร :"
              label-cols-md="3"
            >
              <b-row>
                <b-col cols-md="5" class="mr-md-5">
                  <b-form-radio
                    v-for="bank in bankInfo"
                    :key="bank.length"
                    v-model="chooseBank"
                    :value="bank.bankId"
                    plain
                    name="bank"
                    class="col-md-12"
                  >
                    <h6 class="font-weight-normal">{{bank.fullBankName}}</h6>
                  </b-form-radio>
                </b-col>
                <b-col cols="4" class="pl-2 d-none d-sm-block" v-if="this.valBank == false">
                  <h6 v-if="this.valBank == false" class="text-danger">กรุณาระบุ</h6>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <!-- amount -->
          <b-col cols="12" v-if="choosePayment == 'A'">
            <h6 v-if="this.valAmount == false" class="text-danger d-block d-sm-none">กรุณาระบุ</h6>
            <b-form-group
              class="font-weight-bolder mt-n1"
              label="ยอดที่โอน :"
              label-cols-md="3"
            >
              <div class="d-flex align-items-center">
                <cleave
                  v-model="amountTranfers"
                  class="form-control col-md-5"
                  :raw="false"
                  :options="options.amountTranfers"
                />
                <h6 class="font-weight-normal ml-1">บาท</h6>
                <h6 v-if="this.valAmount == false" class="text-danger ml-md-5 d-none d-sm-block">กรุณาระบุ</h6>
              </div>
            </b-form-group>
          </b-col>
          <!-- date & time -->
          <b-col cols="12" v-if="choosePayment == 'A'">
            <b-form-group
              class="font-weight-bolder"
              label="วันที่ :"
              label-cols-md="3"
            >
            <!-- format date -> :config="{ dateFormat: 'd-m-Y'}" -->
              <div class="d-flex align-items-center">
                <flat-pickr
                  v-model="dateDefault"
                  class="form-control col-md-5"
                  :config="datePickerConfig"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="choosePayment == 'A'">
            <b-form-group
              class="font-weight-bolder"
              label="เวลาประมาณ :"
              label-cols-md="3"
            >
              <div class="d-flex align-items-center">
                <flat-pickr
                  v-model="timePicker"
                  class="form-control col-md-5"
                  :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                />
              </div>
            </b-form-group>
          </b-col>
          <!-- option -->
          <b-col cols="12">
            <h6 v-if="this.valSelectedA == false" class="text-danger d-block d-sm-none mb-n1">กรุณาระบุ</h6>
            <b-form-group
              class="font-weight-bolder"
              label="เพื่อชำระ :"
              label-cols-md="3"
            >
              <!-- โอนเงิน -->
              <div v-if="choosePayment == 'A'" class="d-flex align-items-center">
                <b-form-select
                  v-model="selectedA"
                  :options="this.transfers"
                  value-field="paymentID"
                  text-field="description"
                  class="form-control col-md-5 mr-md-3"
                >
                  <b-form-select-option :value="null">--กรุณาเลือกรายการ--</b-form-select-option>
                </b-form-select>
                <h6 v-if="this.valSelectedA == false" class="text-danger ml-md-5 d-none d-sm-block">กรุณาระบุ</h6>
              </div>
              <!-- หักหน่วยบาท -->
              <div v-if="choosePayment == 'B'" class="d-flex align-items-center">
                <b-form-select
                  v-model="selectedB"
                  :options="this.balanceDeducts"
                  value-field="paymentID"
                  text-field="description"
                  class="col-md-5"
                >
                  <b-form-select-option :value="null">--กรุณาเลือกรายการ--</b-form-select-option>
                </b-form-select>
                <h6 v-if="this.valSelectedB == false" class="text-danger ml-1">กรุณาระบุ</h6>
              </div>
              <!-- หักหน่วยหยวน -->
              <div v-if="choosePayment == 'C'" class="d-flex align-items-center">
                <b-form-select
                  v-model="selectedC"
                  :options="this.yuanDeducts"
                  value-field="paymentID"
                  text-field="description"
                  class="col-md-5"
                >
                </b-form-select>
                <h6 v-if="this.valSelectedC == false" class="text-danger ml-1">กรุณาระบุ</h6>
              </div>
            </b-form-group>
          </b-col>
          <!-- amount Baht -->
          <b-col cols="12" v-if="choosePayment == 'B' && this.selectedB == 4">
            <b-form-group
              class="font-weight-bolder"
              label="จำนวนเงิน :"
              label-cols-md="3"
            >
              <b-row>
                <b-col cols="6">
                  <cleave
                    v-model="amountBaht"
                    class="form-control col-md-12"
                    :raw="false"
                    :options="options.amountBaht"
                  />
                </b-col>
                <b-col cols="2" class="ml-n2">
                  <h6 class="font-weight-normal">บาท</h6>
                </b-col>
                <b-col cols="3" class="ml-n2" v-if="this.valAmountBaht == false">
                  <h6 class=" text-danger">กรุณาระบุ</h6>
                </b-col>
              </b-row>
              <div v-if="this.valBahtBalance == false" class="font-weight-normal" style="color:red">
                *คุณสามารถแลกเงินได้สูงสุด {{format_price(this.balanceLocal.balanceBaht)}} บาท กรุณาแก้ไขจำนวนเงินใหม่
              </div>
            </b-form-group>
          </b-col>
          <!-- amount yuan -->
          <b-col cols="12" v-if="choosePayment == 'C'">
            <b-form-group
              class="font-weight-bolder"
              label="จำนวนหยวน :"
              label-cols-md="3"
            >
              <cleave
                v-model="amountYuan"
                class="form-control col-md-5"
                :raw="false"
                :options="options.amountYuan"
                placeholder="ระบุหรือไม่ระบุก็ได้"
              />
              <div v-if="this.valYuanBalance == false" class="font-weight-normal" style="color:red">
                *คุณสามารถหักยอดเงินได้สูงสุด {{format_price(this.balanceLocal.balanceYuan)}} หยวน กรุณาแก้ไขจำนวนเงินใหม่
              </div>
            </b-form-group>
          </b-col>
          <!-- picture -->
          <!-- <b-col cols="9" v-if="choosePayment == 'A' || choosePayment == 'C'"> -->
          <b-col cols="12" v-if="choosePayment == 'A' || choosePayment == 'C'">
            <b-form-group
              class="font-weight-bolder"
              label="แนบรูป :"
              label-cols-md="3"
            >
              <!-- picture transfer -->
              <div v-if="choosePayment == 'A'" class="d-flex align-items-center">
                <b-form-file
                  class="col-md-5"
                  v-model="pic64"
                  placeholder="Choose a file"
                  drop-placeholder="Drop file here..."
                />
                <h6 class="font-weight-normal ml-1">*แนบสลิปโอนเงิน</h6>
              </div>
              <!-- picture yuan -->
              <div v-if="choosePayment == 'C'" class="d-md-flex align-items-center">
                <b-form-file
                  class="col-md-5"
                  v-model="pic64"
                  placeholder="Choose a file"
                  drop-placeholder="Drop file here..."
                  multiple
                />
                <h6 class="font-weight-normal ml-md-1">*แนบไฟล์เพิ่มเติม หากไม่มีก็ไม่ต้องแนบ</h6>
              </div>
            </b-form-group>
          </b-col>
          <!-- remark -->
          <b-col cols="12">
            <b-form-group
              class="font-weight-bolder"
              label="หมายเหตุ :"
              label-for="h-password"
              label-cols-md="3"
            >
              <!-- tranfer & baht -->
              <b-form-textarea
                v-if="choosePayment == 'A' || choosePayment == 'B'"
                id="textarea-default"
                v-model="remark"
                placeholder=""
                rows="4"
                class="col-md-5"
              />
              <!-- yuan -->
              <b-form-textarea
                v-if="choosePayment == 'C'"
                id="textarea-default"
                v-model="remarkYuan"
                placeholder="โปรดระบุว่าจะให้จ่ายรายการใดบ้าง ไอดีไหนบ้าง แต่ถ้าจะให้จ่ายทุกรายการก็ไม่ต้องลงหมายเหตุ ถ้ามีทั้งใน taobao และ 1688 รบกวนระบุด้วย"
                rows="4"
                class="col-md-5"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <hr/>
        <!-- submit and reset -->
        <b-row>
          <b-col >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              @click="addTransfer()"
              :disabled="this.loadButton == false"
            >
              <b-spinner v-if="this.loadButton == false" small />
              แจ้งชำระเงิน
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <!-- history table -->
    <div class="pb-3">
      <b-card v-if="this.loadpage == false" no-body>
        <!-- <history-payment/> -->
        <b-card-header>
          <span class="d-flex">
            <feather-icon icon="AlignJustifyIcon" size="24"/>
            <h3>ประวัติการแจ้งชำระเงิน</h3>
          </span>
          <hr class="dense"/>
        </b-card-header>
        <!-- pc -->
        <div class="d-none d-sm-block">
          <b-card-body class="d-flex pt-1 pb-0">
            <div class="d-flex align-items-center mb-1 ">
              <span class="px-0 col-1"> วันที่: </span>
              <flat-pickr v-model="date" class="form-control" :config="datePickerConfig"/>
              <span class="px-1"> - </span>
              <span class="px-0 col-1"> ถึงวันที่: </span>
              <flat-pickr v-model="dueDate" class="form-control mr-1" :config="datePickerConfig"/>
              <b-button variant="primary" @click="getHistory()">ค้นหา</b-button>
            </div>
          </b-card-body>
          <b-card-body>
            <b-table
              responsive
              class="position-relative"
              :items="history"
              :fields="fields"
              bordered
              table-class="table-md-responsive text-nowrap"
            >
              <template #cell(paymentID)="data">
                <feather-icon
                  v-if="data.item.statusID == 1 || data.item.statusID == 5"
                  :id="`delete-icon-${data.value}`"
                  icon="TrashIcon"
                  class="cursor-pointer text-danger"
                  size="20"
                  @click="deletePayment(data.value)"
                />
                <b-tooltip
                  title="ลบ"
                  :target="`delete-icon-${data.value}`"
                  :delay="{show: '1500'}"
                />
              </template>
              <template #cell(photoLink)="data">
                <b-img :src="data.value" class="cursor-pointer" width="50px" @click="showImg(data.value)"></b-img>
              </template>
              <template #cell(statusText)="data">
                <div
                  v-if="data.item.statusID == 2 || data.item.statusID == 7"
                  class="text-success"
                >
                  {{data.value}}
                </div>
                <div
                  v-if="data.item.statusID == 1 || data.item.statusID == 5 || data.item.statusID == 6"
                  class="text-warning"
                >
                  {{data.value}}
                </div>
              </template>
            </b-table>
          </b-card-body>
        </div>
        <!-- mobile -->
        <div class="d-block d-sm-none">
          <b-card-body>
            <div class="d-flex align-items-center">
              <span class="px-0 col-2"> วันที่: </span>
              <flat-pickr v-model="date" class="form-control" :config="datePickerConfig"/>
            </div>
            <div class="pt-1 d-flex align-items-center">
              <span class="px-0 col-2"> ถึงวันที่: </span>
              <flat-pickr v-model="dueDate" class="form-control" :config="datePickerConfig"/>
            </div>
            <b-button class="mt-1" variant="primary" @click="getHistory()">ค้นหา</b-button>
          </b-card-body>
          <hr class="dense">
          <b-card-body class="py-0" v-for="item in history" :key="item.length">
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">ชำระเวลา :</b-col>
              <b-col class="pl-0">{{item.paymentDate}}</b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">ช่องทาง :</b-col>
              <b-col class="pl-0">{{item.bank}}</b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">เพื่อชำระ :</b-col>
              <b-col class="pl-0">{{item.description}}</b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">ยอด(บาท) :</b-col>
              <b-col class="pl-0">{{item.amountPaid}}</b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">หมายเหตุ :</b-col>
              <b-col class="pl-0">{{item.remark}}</b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">สถานะ :</b-col>
              <b-col class="pl-0">{{item.statusText}}</b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bolder pr-0 col-4">สลิป :</b-col>
              <b-col v-if="item.photoLink" class="pl-0"><b-link @click="showImg(item.photoLink)">คลิก</b-link></b-col>
            </b-row>
            <div class="text-right">
              <b-button	v-if="item.statusID == 1 || item.statusID == 5" @click="deletePayment(item.paymentID)" class="btn-icon rounded-circle" variant="danger">
                <feather-icon class="icon" icon="Trash2Icon" size="15"/>
              </b-button>
            </div>
            <hr class="dense">
          </b-card-body>
        </div>
      </b-card>
    </div>

    <b-modal ref="show-img" hide-footer centered>
      <div class="text-center">
        <b-img class="px-0" :src="this.imgLink" fluid ></b-img>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BCard, BTabs, BTab, BCardBody,
  BInputGroup, BFormSpinbutton, BFormTextarea, BFormFile, BOverlay, BSpinner, BImg, BFormRadio, BFormSelect,
  BFormSelectOption, BTable, BCardHeader, BTooltip, BLink, BModal, BBadge
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { formatDate_eng, formatDate_dmy, format_price, setFileBase64 } from '@/views/global_function.js'
import HistoryPayment from './history-payment.vue'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";

export default {
  components: {
    BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BCard, BTabs, BTab, BCardBody,
    BInputGroup, BFormSpinbutton, BFormTextarea, BFormFile, BOverlay, BSpinner, BImg, BFormRadio, BFormSelect,
    BFormSelectOption, BTable, ToastificationContent, BCardHeader, BTooltip, BLink, BModal, BBadge,

    flatPickr,
    Cleave,
    HistoryPayment
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),

      //loadpage
      loadpage: false,

      // radio
      choosePayment: 'A',
      chooseBank: '',
      bankInfo: [],

      // date&time
      dateDefault: new Date(),
      timePicker: new Date().toLocaleString(undefined, {hour: '2-digit', hour12: false, minute:'2-digit'}),

      // list payment
      selectedA: null,
      selectedB: null,
      selectedC: null,
      transfers: [],
      balanceDeducts: [],
      yuanDeducts: [],

      //picture base64
      pic64: null,

      selected: null,
      amountTranfers: null,
      amountBaht: '',
      amountYuan: '',
      remark: '',
      remarkYuan: '',

      options: {
        amountTranfers: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralPositiveOnly: true
        },
        amountYuan: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralPositiveOnly: true
        },
        amountBaht: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralPositiveOnly: true
        },
      },

      valBank: true,
      valAmount: true,
      valAmountBaht: true,
      valSelectedA: true,
      valSelectedB: true,
      valSelectedC: true,
      valBahtBalance: true,
      valYuanBalance: true,
      balanceLocal: JSON.parse(localStorage.getItem('all_balance')),

      //history table
      date: null,
      dueDate: null,
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },
      history: [],
      fields: [
        { key: 'paymentDate', label: 'ชำระเวลา', sortable: true },
        { key: 'bank', label: 'ช่องทาง' },
        { key: 'description', label:'เพื่อชำระ' },
        { key: 'amountPaid', label:'ยอด(บาท)', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'photoLink', label: 'สลิป', thClass: 'text-center', tdClass: 'text-center'},
        { key: 'remark', label:'หมายเหตุ' },
        { key: 'statusText', label:'สถานะ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'paymentID', label:'ลบ', thClass: 'text-center', tdClass: 'text-center' },
      ],

      imgLink: '',
      loadButton: true,
      checkTypeC: true,
    };
  },
  async created() {
    this.getHistory()
    this.getListPayment()

  },
  methods: {
    formatDate_eng,
    formatDate_dmy,
    format_price,
    setFileBase64,
    async getListPayment() {
      this.loadpage = true
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        // "CustomerID": 1,
        "loginToken": this.userData.data.customerInfo.loginToken,
      });
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Payment/load-payment-page',
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
        data : data
      };
      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.transfers = keepdata.transfers.filter(x => x.paymentID != 4)
      this.balanceDeducts = keepdata.balanceDeducts
      this.yuanDeducts = keepdata.balanceYuanDeducts
      this.bankInfo = keepdata.bankInfos
      this.selectedC = keepdata.balanceYuanDeducts[0].paymentID
      this.loadpage = false
    },
    async addTransfer(){
      var datetime = ''
      var time12 = this.timePicker.split(":")
      if ((this.chooseBank == '' || this.amountTranfers == null || this.selectedA == null) && this.choosePayment == 'A') {
        if(this.chooseBank == '')
        this.valBank = false
        if(this.amountTranfers == null)
        this.valAmount = false
        if(this.selectedA == null)
        this.valSelectedA = false
      } else if (this.selectedB == null && this.choosePayment == 'B') {
        this.valSelectedB = false
      } else if (this.selectedB == 4 && this.amountBaht == '' && this.choosePayment == 'B') {
        this.valAmountBaht = false
      } else if (this.selectedC == null && this.choosePayment == 'C'){
        this.valSelectedC = false
      } else {
        this.loadButton = false
        var axios = require('axios');
        if (this.choosePayment == 'A') {
          if ( this.dateDefault.length == 10 ) {
            if (time12[0] == '24') {
              datetime = formatDate_eng(this.dateDefault) + ' ' + '00:' + time12[1]
            } else {
              datetime = formatDate_eng(this.dateDefault) + ' ' + this.timePicker
            }
          } else  {
            if (time12[0] == '24') {
              datetime = formatDate_eng(this.dateDefault.toISOString().slice(0, 10)) + ' ' + '00:' + time12[1]
            } else {
              datetime = formatDate_eng(this.dateDefault.toISOString().slice(0, 10)) + ' ' + this.timePicker
            }
          }
          var FormData = require('form-data');
          var data = new FormData();
          data.append('Amount', Number(this.amountTranfers.replace(/,/g, "")));
          data.append('BankID', this.chooseBank);
          data.append('LoginToken', this.userData.data.customerInfo.loginToken);
          data.append('Image', this.pic64);
          data.append('PaymentDescription', this.transfers.filter(x => x.paymentID == this.selectedA)[0].description);
          data.append('PaymentID', this.selectedA);
          data.append('Remark', this.remark);
          data.append('TransferDate', datetime);

          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/Payment/add-transfer-payment',
            data : data,
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('auth_token'),
              'Content-Type': 'multipart/form-data' },
          };
        } else if (this.choosePayment == 'C') {
          if ( await this.amountYuan != '' ) {
            var yuan = Number(this.amountYuan.replace(/,/g, ""))
          }
          var FormData = require('form-data');
          var data = new FormData();
          data.append('Amount', this.amountYuan != '' ? yuan : '');
          data.append('LoginToken', this.userData.data.customerInfo.loginToken);
          data.append('Image', this.pic64 ? this.pic64[0] : this.pic64);
          data.append('PaymentDescription', this.yuanDeducts.filter(x => x.paymentID == this.selectedC)[0].description);
          data.append('PaymentID', this.selectedC);
          data.append('Remark', this.remarkYuan);
          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/Payment/add-balance-yuan-deduct-payment',
            data : data,
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('auth_token'),
              'Content-Type': 'multipart/form-data' },
          };
        } else if (this.choosePayment == 'B') {
          var baht = Number(this.amountBaht.replace(/,/g, ""))
          if (this.selectedB == 4 && baht > this.balanceLocal.balanceBaht) {
            this.loadButton = true
            return this.valBahtBalance = false
          } else {
            if (this.selectedB == 4) {
              var data = JSON.stringify({
                "amount": baht,
                "loginToken": this.userData.data.customerInfo.loginToken,
                "paymentDescription": this.balanceDeducts.filter(x => x.paymentID == this.selectedB)[0].description,
                "paymentID": this.selectedB,
                "remark": this.remark,
              });
              var config = {
                method: 'post',
                url: taobaoService_dotnet + 'app/Payment/add-balance-deduct-payment',
                headers: {
                  'Authorization': 'Bearer ' + localStorage.getItem('auth_token'), 
                  'Content-Type': 'application/json'
                },
                data : data
              };
            } else {
              var des = this.balanceDeducts.filter(x => x.paymentID == this.selectedB)[0].description.split(" ");
              var text = des.slice(3, 4)
              var amount = await text[0].replace(/,/g, "");
              var data = JSON.stringify({
                "amount": Number(amount),
                "loginToken": this.userData.data.customerInfo.loginToken,
                "paymentDescription": this.balanceDeducts.filter(x => x.paymentID == this.selectedB)[0].description,
                "paymentID": this.selectedB,
                "remark": this.remark,
              });
              var config = {
                method: 'post',
                url: taobaoService_dotnet + 'app/Payment/add-balance-deduct-payment',
                headers: {
                  'Authorization': 'Bearer ' + localStorage.getItem('auth_token'), 
                  'Content-Type': 'application/json'
                },
                data : data
              };
            }
          }
        }
        var keepdata = []
        await axios(config)
        .then(function (response) {
          keepdata = response.data
        })
        .catch(function (error) {
        console.log(error);
        return
        });
        if (keepdata.status == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แจ้งชำระเงินเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          await this.$router.push({path: '/'})
          this.$router.push({path: '/finance/transfer'})
        } else if (keepdata.status == 'error') {
          this.$swal({
            title: 'แจ้งชำระเงินไม่สำเร็จ',
            text: keepdata.error_description,
            icon: 'warning',
            confirmButtonText: 'เข้าใจแล้ว',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        }
        this.loadButton = true
      }
    },

    async getHistory(){
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        "loginToken": this.userData.data.customerInfo.loginToken,
        "startDate": this.date,
        "endDate": this.dueDate,
        "isDescending": true
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Payment/load-payment-history-page',
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.history = keepdata.dataList
      this.date = keepdata.startDate
      this.dueDate = keepdata.endDate
    },
    async deletePayment(paymentId){
      this.$swal({
        title: 'ลบการแจ้งชำระเงิน ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการลบรายการนี้ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          var axios = require('axios');
          var data = JSON.stringify({
            "loginToken": this.userData.data.customerInfo.loginToken,
            "paymentID": paymentId,
          });

          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/Payment/delete-payment',
            headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
            'Content-Type': 'application/json'
            },
            data : data
          };

          await axios(config)
          .then(function (response) {
          })
          .catch(function (error) {
            console.log(error);
          });
          await this.$router.push({path: '/'})
          this.$router.push({path: '/finance/transfer'})
          // window.location.reload()
          // this.getHistory()
          // this.getListPayment()
        }
      })
    },
    async showImg(img) {
      this.imgLink = await img
      this.$refs['show-img'].show()
    },
    async addTranfersBalance() {
      var datetime = ''
      var resize_width = 400; //without px
      var item = this.pic64 //get the image selected
      var reader = new FileReader(); //create a FileReader
      //image turned to base64-encoded Data URI.
      reader.readAsDataURL(item);
      reader.name = item.name;//get the image's name
      reader.size = item.size; //get the image's size
      reader.$path = item.$path; //get the image's $path
      reader.onload = async (event) => {
        var img = new Image();//create a image
        img.src = event.target.result;//result is base64-encoded Data URI
        img.name = event.target.name;//set name (optional)
        img.size = await event.target.size;//set size (optional)
        img.onload = async (el) => {
          var elem = document.createElement('canvas');//create a canvas
          //scale the image to 600 (width) and keep aspect ratio
          var scaleFactor = resize_width / el.target.width;
          elem.width = resize_width;
          elem.height = el.target.height * scaleFactor;
          //draw in canvas
          var ctx = elem.getContext('2d');
          ctx.drawImage(el.target, 0, 0, elem.width, elem.height);
          //get the base64-encoded Data URI from the resize image
          var srcEncoded = ctx.canvas.toDataURL('image/png', 1);

          var arr = srcEncoded.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
          while(n--){
            u8arr[n] = bstr.charCodeAt(n);
          }
          if ( this.dateDefault.length == 10 ) {
            datetime = formatDate_eng(this.dateDefault) + ' ' + this.timePicker
          } else  {
            datetime = formatDate_eng(this.dateDefault.toISOString().slice(0, 10)) + ' ' + this.timePicker
          }
          var FormData = require('form-data');
          var data = new FormData();
          data.append('Amount', Number(this.amountTranfers.replace(/,/g, "")));
          data.append('BankID', this.chooseBank);
          data.append('LoginToken', this.userData.data.customerInfo.loginToken);
          data.append('Image', new File ([u8arr], 'PNG', {type:mime}));
          data.append('PaymentDescription', this.transfers.filter(x => x.paymentID == this.selectedA)[0].description);
          data.append('PaymentID', this.selectedA);
          data.append('Remark', this.remark);
          data.append('TransferDate', datetime);

          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/Payment/add-transfer-payment',
            data : data,
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('auth_token'),
              'Content-Type': 'multipart/form-data' },
          };

          var keepdata = []
          await axios(config)
          .then(function (response) {
            keepdata = response.data
          })
          .catch(function (error) {
          console.log(error);
          return
          });
          if (keepdata.status == 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'สำเร็จ',
                icon: 'CheckIcon',
                text: 'แจ้งชำระเงินเรียบร้อย',
                variant: 'success',
              },
            },
            {
              position: 'top-center',
            })
            await this.$router.push({path: '/'})
            this.$router.push({path: '/finance/transfer'})
          } else if (keepdata.status == 'error') {
            this.$swal({
              title: 'แจ้งชำระเงินไม่สำเร็จ',
              text: keepdata.error_description,
              icon: 'warning',
              confirmButtonText: 'เข้าใจแล้ว',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
          this.loadButton = true
          this.checkTypeC = true
        }
      }
    },
    async addYuanBalance() {
      var resize_width = 400; //without px
      var item = this.pic64[0] //get the image selected
      var reader = new FileReader(); //create a FileReader
      //image turned to base64-encoded Data URI.
      reader.readAsDataURL(item);
      reader.name = item.name;//get the image's name
      reader.size = item.size; //get the image's size
      reader.$path = item.$path; //get the image's $path
      reader.onload = async (event) => {
        var img = new Image();//create a image
        img.src = event.target.result;//result is base64-encoded Data URI
        img.name = event.target.name;//set name (optional)
        img.size = await event.target.size;//set size (optional)
        img.onload = async (el) => {
          var elem = document.createElement('canvas');//create a canvas
          //scale the image to 600 (width) and keep aspect ratio
          var scaleFactor = resize_width / el.target.width;
          elem.width = resize_width;
          elem.height = el.target.height * scaleFactor;
          //draw in canvas
          var ctx = elem.getContext('2d');
          ctx.drawImage(el.target, 0, 0, elem.width, elem.height);
          //get the base64-encoded Data URI from the resize image
          var srcEncoded = ctx.canvas.toDataURL('image/png', 1);

          var arr = srcEncoded.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
          while(n--){
            u8arr[n] = bstr.charCodeAt(n);
          }
          if ( await this.amountYuan != '' ) {
            var yuan = Number(this.amountYuan.replace(/,/g, ""))
          }
          var FormData = require('form-data');
          var data = new FormData();
          data.append('Amount', this.amountYuan != '' ? yuan : '');
          data.append('LoginToken', this.userData.data.customerInfo.loginToken);
          data.append('Image', this.pic64 ? new File ([u8arr], 'PNG', {type:mime}) : this.pic64);
          data.append('PaymentDescription', this.yuanDeducts.filter(x => x.paymentID == this.selectedC)[0].description);
          data.append('PaymentID', this.selectedC);
          data.append('Remark', this.remarkYuan);
          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/Payment/add-balance-yuan-deduct-payment',
            data : data,
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('auth_token'),
              'Content-Type': 'multipart/form-data' },
          };

          var keepdata = []
          await axios(config)
          .then(function (response) {
            keepdata = response.data
          })
          .catch(function (error) {
          console.log(error);
          return
          });
          if (keepdata.status == 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'สำเร็จ',
                icon: 'CheckIcon',
                text: 'แจ้งชำระเงินเรียบร้อย',
                variant: 'success',
              },
            },
            {
              position: 'top-center',
            })
            await this.$router.push({path: '/'})
            this.$router.push({path: '/finance/transfer'})
          } else if (keepdata.status == 'error') {
            this.$swal({
              title: 'แจ้งชำระเงินไม่สำเร็จ',
              text: keepdata.error_description,
              icon: 'warning',
              confirmButtonText: 'เข้าใจแล้ว',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
          this.loadButton = true
          this.checkTypeC = true
        }
      }
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
